'use strict';

const GAP = 32;
const containerMarginMobile = "16px";
const breakpoints = {
    phoneSmall: {
        min: 320},
    phoneLarge: {
        max: 767
    },
    tablet: {
        min: 768,
        max: 959 + 2 * GAP
    }};
// Phone small 320px (iPhone SE, 5S)
const phoneSmall = `${breakpoints.phoneSmall.min}px`;
const phoneLargeMax = `${breakpoints.phoneLarge.max}px`;
// Tablet 768px
const tablet = `${breakpoints.tablet.min}px`;
const tabletMax = `${breakpoints.tablet.max}px`;

exports.breakpoints = breakpoints;
exports.containerMarginMobile = containerMarginMobile;
exports.phoneLargeMax = phoneLargeMax;
exports.phoneSmall = phoneSmall;
exports.tablet = tablet;
exports.tabletMax = tabletMax;
//# sourceMappingURL=dimensions.cjs.map
